import {Flex, Text, Heading, Image} from '@chakra-ui/react';
const CatIpsum = () => {
  return (
    <Flex direction="column" align="center">
      <Heading>Cat Ipsum</Heading>
      <Text>
        Crash against wall but walk away like nothing happened being gorgeous
        with belly side up. Eat the fat cats food poop on the floor, break a
        planter, sprint, eat own hair, vomit hair, hiss, chirp at birds, eat a
        squirrel, hide from fireworks, lick toe beans, attack christmas tree or
        scream for no reason at 4 am destroy couch, but rub whiskers on bare
        skin act innocent. Growl at dogs in my sleep. Kitten is playing with
        dead mouse suddenly go on wild-eyed crazy rampage but sit and stare. I
        like frogs and 0 gravity drool, step on your keyboard while you're
        gaming and then turn in a circle run off table persian cat jump eat
        fish, steal mom's crouton while she is in the bathroom but eat the
        rubberband adventure always. Paw your face to wake you up in the morning
        shred all toilet paper and spread around the house so eat the rubberband
        just going to dip my paw in your coffee and do a taste test - oh never
        mind i forgot i don't like coffee - you can have that back now yet lick
        master's hand at first then bite because im moody stare at owner
        accusingly then wink. Wack the mini furry mouse i heard this rumor where
        the humans are our owners, pfft, what do they know?! eat fish on floor
        so have my breakfast spaghetti yarn and reaches under door into adjacent
        room cereal boxes make for five star accommodation has closed eyes but
        still sees you. Spit up on light gray carpet instead of adjacent
        linoleum i love cuddles for warm up laptop with butt lick butt fart
        rainbows until owner yells pee in litter box hiss at cats and howl on
        top of tall thing and trip owner up in kitchen i want food bite the
        neighbor's bratty kid. Loved it, hated it, loved it, hated it. As lick i
        the shoes. Attack like a vicious monster warm up laptop with butt lick
        butt fart rainbows until owner yells pee in litter box hiss at cats and
        climb a tree, wait for a fireman jump to fireman then scratch his face.
        Poop in a handbag look delicious and drink the soapy mopping up water
        then puke giant foamy fur-balls play riveting piece on synthesizer
        keyboard. Annoy owner until he gives you food say meow repeatedly until
        belly rubs, feels good cat slap dog in face. With tail in the air attack
        the dog then pretend like nothing happened for in the middle of the
        night i crawl onto your chest and purr gently to help you sleep ask for
        petting murr i hate humans they are so annoying or catch small lizards,
        bring them into house, then unable to find them on carpet rub against
        owner because nose is wet. Where is my slave? I'm getting hungry
        immediately regret falling into bathtub get video posted to internet for
        chasing red dot. Scratch me there, elevator butt. Attempt to leap
        between furniture but woefully miscalibrate and bellyflop onto the
        floor; what's your problem? i meant to do that now i shall wash myself
        intently. Flex claws on the human's belly and purr like a lawnmower what
        a cat-ass-trophy! cat ass trophy or look at dog hiiiiiisssss lick butt,
        or meow all night having their mate disturbing sleeping humans. Spit up
        on light gray carpet instead of adjacent linoleum
        asdflkjaertvlkjasntvkjn (sits on keyboard) for licks paws. I heard this
        rumor where the humans are our owners, pfft, what do they know?! use lap
        as chair tuxedo cats always looking dapper but stare at owner accusingly
        then wink scratch the postman wake up lick paw wake up owner meow meow
        for crusty butthole meow.
      </Text>
      <Text>
        Play time eats owners hair then claws head poop on grasses. Demand to
        have some of whatever the human is cooking, then sniff the offering and
        walk away Gate keepers of hell stare at guinea pigs a nice warm laptop
        for me to sit on reaches under door into adjacent room. Kitty kitty
        pussy cat doll sun bathe rub whiskers on bare skin act innocent. Lick
        left leg for ninety minutes, still dirty am in trouble, roll over, too
        cute for human to get mad. This is the day have my breakfast spaghetti
        yarn, but meow meow you are my owner so here is a dead rat or flee in
        terror at cucumber discovered on floor. Haha you hold me hooman i
        scratch cat jumps and falls onto the couch purrs and wakes up in a new
        dimension filled with kitty litter meow meow yummy there is a bunch of
        cats hanging around eating catnip . Eat the rubberband i like big cats
        and i can not lie, so groom forever, stretch tongue and leave it
        slightly out, blep shed everywhere shed everywhere stretching attack
        your ankles chase the red dot, hairball run catnip eat the grass sniff.
        Fish i must find my red catnip fishy fish cats are a queer kind of folk,
        so run around the house at 4 in the morning or chirp at birds snob you
        for another person. Relentlessly pursues moth bite the neighbor's bratty
        kid for play time, but i will be pet i will be pet and then i will hiss
        purr purr purr until owner pets why owner not pet me hiss scratch meow.
      </Text>
      <Text>
        My left donut is missing, as is my right under the bed, or throwup on
        your pillow, and as lick i the shoes yet human is washing you why halp
        oh the horror flee scratch hiss bite but i show my fluffy belly but it's
        a trap! if you pet it i will tear up your hand try to hold own back foot
        to clean it but foot reflexively kicks you in face, go into a rage and
        bite own foot, hard. Eat the fat cats food. Let me in let me out let me
        in let me out let me in let me out who broke this door anyway stand in
        doorway, unwilling to chose whether to stay in or go out chase red laser
        dot and lick butt, for eat the fat cats food yet purr when give birth.
        Cats are cute who's the baby, but i shall purr myself to sleep for
        mmmmmmmmmeeeeeeeeooooooooowwwwwwww yet i like big cats and i can not
        lie. Throwup on your pillow hide at bottom of staircase to trip human.
        Please let me outside pouty face yay! wait, it's cold out please let me
        inside pouty face oh, thank you rub against mommy's leg oh it looks so
        nice out, please let me outside again the neighbor cat was mean to me
        please let me back inside stare at guinea pigs yet purrrrrr ask to go
        outside and ask to come inside and ask to go outside and ask to come
        inside love and coo around boyfriend who purrs and makes the perfect
        moonlight eyes so i can purr and swat the glittery gleaming yarn to him
        (the yarn is from a $125 sweater) cats are fats i like to pets them they
        like to meow back. Steal the warm chair right after you get up cat is
        love, cat is life but cats are fats i like to pets them they like to
        meow back for kitty cat snacks, yet my water bowl is clean and freshly
        replenished, so i'll drink from the toilet i like cats because they are
        fat and fluffy. Bite nose of your human cough hairball, eat toilet
        paper, or catch mouse and gave it as a present funny little cat chirrup
        noise shaking upright tail when standing next to you so russian blue
        lick sellotape poop in litter box, scratch the walls. Sniff other cat's
        butt and hang jaw half open thereafter. Attempt to leap between
        furniture but woefully miscalibrate and bellyflop onto the floor; what's
        your problem? i meant to do that now i shall wash myself intently eat
        fish on floor or play with twist ties. Destroy house in 5 seconds
        destroy couch, so ask for petting meow loudly just to annoy owners but
        stare at guinea pigs. Morning beauty routine of licking self poop in
        litter box, scratch the walls or mmmmmmmmmeeeeeeeeooooooooowwwwwwww.
        Kitty pounce, trip, faceplant you didn't see that no you didn't
        definitely didn't lick, lick, lick, and preen away the embarrassment sit
        in window and stare oooh, a bird, yum naughty running cat bite off
        human's toes purrrrrr but meow meow. Lie in the sink all day cat slap
        dog in face yet annoy owner until he gives you food say meow repeatedly
        until belly rubs, feels good meowing non stop for food yet howl on top
        of tall thing. Make plans to dominate world and then take a nap my slave
        human didn't give me any food so i pooped on the floor yet kitty
        scratches couch bad kitty for jump up to edge of bath, fall in then
        scramble in a mad panic to get out annoy owner until he gives you food
        say meow repeatedly until belly rubs, feels good. Catching very fast
        laser pointer kitty scratches couch bad kitty bleghbleghvomit my furball
        really tie the room together. And sometimes switches in french and say
        "miaou" just because well why not fall over dead (not really but gets
        sypathy) so run outside as soon as door open for meow meow for play time
        howl uncontrollably for no reason sleep everywhere, but not in my bed.
        Eat an easter feather as if it were a bird then burp victoriously, but
        tender howl uncontrollably for no reason and stinky cat leave dead
        animals as gifts. Have my breakfast spaghetti yarn. Try to jump onto
        window and fall while scratching at wall murr i hate humans they are so
        annoying. Get suspicious of own shadow then go play with toilette paper
        pet my belly, you know you want to; seize the hand and shred it! try to
        hold own back foot to clean it but foot reflexively kicks you in face,
        go into a rage and bite own foot, hard. Headbutt owner's knee allways
        wanting food my cat stared at me he was sipping his tea, too and you
        call this cat food. Have secret plans is good you understand your place
        in my world or poop on grasses give attitude. I vomit in the bed in the
        middle of the night hunt anything that moves, yet naughty running cat
        kitty pounce, trip, faceplant you didn't see that no you didn't
        definitely didn't lick, lick, lick, and preen away the embarrassment
        scratch at the door then walk away. While happily ignoring when being
        called when owners are asleep, cry for no apparent reason and human is
        behind a closed door, emergency! abandoned! meeooowwww!!!, kick up
        litter yet good now the other hand, too cough furball into food bowl
        then scratch owner for a new one scream at teh bath.
      </Text>
      <Text>
        Murr i hate humans they are so annoying plays league of legends for
        stare out cat door then go back inside and spend all night ensuring
        people don't sleep sleep all day haha you hold me hooman i scratch. Eat
        fish on floor hate dogs for find something else more interesting. Warm
        up laptop with butt lick butt fart rainbows until owner yells pee in
        litter box hiss at cats. I'm bored inside, let me out i'm lonely
        outside, let me in i can't make up my mind whether to go in or out,
        guess i'll just stand partway in and partway out, contemplating the
        universe for half an hour how dare you nudge me with your foot?!?! leap
        into the air in greatest offense! meow meow mama what a cat-ass-trophy!
        just going to dip my paw in your coffee and do a taste test - oh never
        mind i forgot i don't like coffee - you can have that back now shred all
        toilet paper and spread around the house. Sit in a box for hours. I want
        to go outside let me go outside nevermind inside is better slap kitten
        brother with paw for jump on counter removed by human jump on counter
        again removed by human meow before jumping on counter this time to let
        the human know am coming back for meeeeouw and sitting in a box but love
        to play with owner's hair tie and cat snacks. Eats owners hair then
        claws head russian blue, or sugar, my siamese, stalks me (in a good
        way), day and night or stretch. Hide when guests come over get
        suspicious of own shadow then go play with toilette paper trip owner up
        in kitchen i want food. Yowling nonstop the whole night mess up all the
        toilet paper but stick butt in face cats are fats i like to pets them
        they like to meow back pee in human's bed until he cleans the litter box
        for spot something, big eyes, big eyes, crouch, shake butt, prepare to
        pounce eat all the power cords. Stretch out on bed. Scream at teh bath
        cry louder at reflection freak human out make funny noise mow mow mow
        mow mow mow success now attack human go into a room to decide you didn't
        want to be in there anyway. White cat sleeps on a black shirt lick left
        leg for ninety minutes, still dirty always hungry. Slap owner's face at
        5am until human fills food dish have my breakfast spaghetti yarn sit and
        stare and put butt in owner's face. Meow meow, i tell my human i could
        pee on this if i had the energy crash against wall but walk away like
        nothing happened or dont wait for the storm to pass, dance in the rain.
        Fight an alligator and win groom forever, stretch tongue and leave it
        slightly out, blep or intently sniff hand, for dream about hunting
        birds, for eat too much then proceed to regurgitate all over living room
        carpet while humans eat dinner. Roll on the floor purring your whiskers
        off fight an alligator and win love you, then bite you so pelt around
        the house and up and down stairs chasing phantoms or rub whiskers on
        bare skin act innocent for i like big cats and i can not lie cats making
        all the muffins. Making bread on the bathrobe swat at dog, and furrier
        and even more furrier hairball or show belly so who's the baby, and
        munch on tasty moths so kitty kitty pussy cat doll. Meow i can haz. I
        like big cats and i can not lie swipe at owner's legs. Jump around on
        couch, meow constantly until given food, lick master's hand at first
        then bite because im moody or lie on your belly and purr when you are
        asleep. As lick i the shoes sit on human caticus cuteicus yet cat walks
        in keyboard , for i am the best. Purr like an angel furball roll roll
        roll bring your owner a dead bird. I vomit in the bed in the middle of
        the night if human is on laptop sit on the keyboard chew the plant, yet
        hey! you there, with the hands for scratch the box yet leave fur on
        owners clothes so burrow under covers.
      </Text>
      <Image
        src="https://media.giphy.com/media/BzyTuYCmvSORqs1ABM/source.gif"
        alt="Cat shooting lightning bolts"
        width="clamp(200px, 50%, 600px)"
      ></Image>
    </Flex>
  );
};

export default CatIpsum;
